import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faHeart as heartSolid, faCheck, faBolt } from "@fortawesome/free-solid-svg-icons";
import { faHeart as heartRegular, faEye } from "@fortawesome/free-regular-svg-icons";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import StringSlice from "../../../../Helpers/StringSlice";
import StarRating from "./StarRating";
import { useLanguage } from "../../../../Context/LanguageContext";
import { useCart } from "../../../../Context/CartChangerContext";
import { useWishlist } from "../../../../Context/WishlistContext";
import "./ProductCard.css";

// بديل موحّد لـ WebSiteProduct.js و TopRatedProducts.js، كانوا نفس الكود
// تقريبًا حرفيًا. أي مكان محتاج يعرض كارت منتج بيستخدم ده بدل ما يتكرر.
export default function ProductCard ( { id, title, description, img, price, discount, rating, sale } )
{
    const { t } = useLanguage();
    const { addToCart } = useCart();
    const { isInWishlist, toggleWishlist } = useWishlist();
    const navigate = useNavigate();
    const location = useLocation();
    const [ addingToCart, setAddingToCart ] = useState( false );
    const [ addedToCart, setAddedToCart ] = useState( false );
    const [ togglingWishlist, setTogglingWishlist ] = useState( false );

    const wishlisted = isInWishlist( id );

    // اطلب الآن: بيوديك لصفحة مراجعة قبل تأكيد الطلب فعليًا (وليس إنشاء فوري)
    const handleOrderNow = ( e ) =>
    {
        e.preventDefault();
        e.stopPropagation();
        navigate( `/checkout?product_id=${ id }&count=1`, { state: { from: location.pathname } } );
    };

    const handleToggleWishlist = async ( e ) =>
    {
        e.preventDefault();
        e.stopPropagation();

        if ( togglingWishlist ) return;
        setTogglingWishlist( true );
        const result = await toggleWishlist( id );
        setTogglingWishlist( false );

        if ( !result.success && result.reason === 'auth' )
        {
            navigate( '/auth', { state: { from: location.pathname } } );
        }
    };

    const handleAddToCart = async ( e ) =>
    {
        e.preventDefault();
        e.stopPropagation();

        if ( addingToCart ) return;
        setAddingToCart( true );
        const result = await addToCart( id, 1 );
        setAddingToCart( false );

        if ( !result.success )
        {
            if ( result.reason === 'auth' )
            {
                navigate( '/auth', { state: { from: location.pathname } } );
                return;
            }
            if ( result.reason === 'stock' )
            {
                alert( t( 'singleProduct.stockAlert' ) );
                return;
            }
            alert( t( 'errors.serverError' ) );
            return;
        }

        setAddedToCart( true );
        setTimeout( () => setAddedToCart( false ), 1400 );
    };

    return (
        <div className="product-card">
            <NavLink to={ `/product/${ id }` } className="text-decoration-none">
                <div className="product-card-image">
                    <img src={ img } alt={ title || "" } />

                    <div className="product-card-overlay">
                        <button
                            className={ `pc-overlay-btn ${ wishlisted ? "is-active" : "" }` }
                            onClick={ handleToggleWishlist }
                            disabled={ togglingWishlist }
                            aria-label="toggle wishlist"
                        >
                            <FontAwesomeIcon icon={ wishlisted ? heartSolid : heartRegular } />
                        </button>
                        <button className="pc-overlay-btn">
                            <FontAwesomeIcon icon={ faEye } />
                        </button>
                    </div>

                    { sale && <span className="product-card-badge">{ t( 'product.saleBadge' ) }</span> }
                    { wishlisted && (
                        <span className="pc-wishlist-persist">
                            <FontAwesomeIcon icon={ heartSolid } style={ { fontSize: "13px" } } />
                        </span>
                    ) }
                </div>

                <div className="product-card-body">
                    <p className="product-card-eyebrow">{ StringSlice( title || "", 35 ) }</p>
                    <p className="product-card-desc">{ StringSlice( description || "", 40 ) }</p>

                    <StarRating rating={ rating } />

                    <div className="product-card-footer">
                        <div>
                            <span className="price-current">{ discount }$</span>
                            { price && <span className="price-original">{ price }$</span> }
                        </div>
                        <div className="product-card-actions">
                            <button
                                type="button"
                                className="product-card-order-btn"
                                onClick={ handleOrderNow }
                                aria-label="order now"
                                title="اطلب الآن"
                            >
                                <FontAwesomeIcon icon={ faBolt } />
                            </button>
                            <button
                                type="button"
                                className={ `product-card-cart-btn ${ addedToCart ? "is-added" : "" }` }
                                onClick={ handleAddToCart }
                                disabled={ addingToCart }
                                aria-label="add to cart"
                            >
                                <FontAwesomeIcon icon={ addedToCart ? faCheck : faCartShopping } />
                            </button>
                        </div>
                    </div>
                </div>
            </NavLink>
        </div>
    );
}
